import firebase from 'firebase';



 // For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBJIjDHqsPFugxM03wjophihj969LLDo58",
  authDomain: "med-fashion.firebaseapp.com",
  databaseURL: "https://med-fashion-default-rtdb.firebaseio.com",
  projectId: "med-fashion",
  storageBucket: "med-fashion.appspot.com",
  messagingSenderId: "575074548146",
  appId: "1:575074548146:web:7be2905e07e22f52538cab",
  measurementId: "G-MB3VW5XTXG"
};

firebase.initializeApp(firebaseConfig);
var auth = firebase.auth();


export default auth;






